import AccessDeniedContent from '@components/molecules/access-denied-content/access-denied-content';
// eslint-disable-next-line import/no-cycle
import useTryNavigate from '@hooks/useTryNavigate';

interface Props {
    modularProductPermission?: boolean;
}

export default function AccessDenied({ modularProductPermission }: Props) {
    const { allowedHomePage } = useTryNavigate();

    return (
        <AccessDeniedContent
            modularProductPermission={modularProductPermission}
            homePath={allowedHomePage}
        />
    );
}
